import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from './subcomponents/Dropzone';
import ProgressBar from './subcomponents/ProgressBar';
import { BsCheckCircle } from 'react-icons/bs';
import moment from "moment";
import { DocumentApi, ServiceUtil, metadataService} from "../_services/";
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

import { SlBusyIndicator, SlButton } from "../components/editors";
import { getDocumentType } from "../_helpers";

export class DocumentUpload extends Component {
    constructor(props) {
        super(props)
        this.initState = {
          files: [],
          model: {},
          uploading: false,
          uploadProgress: {},
          successfullUploaded: false,
          uploadTitle: props.uploadTitle,
          uploadContent: "UploadContent",
          origin: props.origin,
          documentStatus: props.documentStatus,
          documentStatusClass: props.documentStatusClass,
          documentApproved: "Approved",
          leadId: props.leadId,
          documentClassification: props.documentClassification,
          hideDropZone: props.hideDropZone,
          lastModified: props.lastModified,
          isBusy: true,
          showModal: false,
          currentFileName: "",
          uploadError: "",
          fileError: {
            isError: false,
            errorTitle: "",
            errorText: "",
          },
        };
        this.state = {
          ...this.initState,
        };

        this.onFilesAdded = this.onFilesAdded.bind(this);
        this.uploadFiles = this.uploadFiles.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        this.renderDropZone = this.renderDropZone.bind(this);
        this.confirmedUpload = this.confirmedUpload.bind(this);
        this.cancelUpload = this.cancelUpload.bind(this);
    }

    onFilesAdded(file = []) {
        let fileError = { isError: false, errorTitle: "", errorText: ""} 
        let currentFileName = "";
        let maxFileSizeInBytes = 10; // 10mb
        let acceptableTypes = metadataService.validFileTypeList();
        const {maxAllowedFiles} = this.props;
        if(file && file.length > maxAllowedFiles){
            fileError = {isError : true, errorTitle: "FilesAllowedErrorTitle", errorText: "FilesAllowedErrorText"}
        }else{
            file.forEach(f => {
                let fileSize = (f.size / (1024*1024)).toFixed(2);
                let isValidFileType = acceptableTypes.includes(f.type);
                //let fileError = { isError: false, errorTitle: "", errorText: ""}
                if(!isValidFileType) { // bad type
                    fileError = {isError : true, errorTitle: "FileTypeErrorTitle", errorText: "FileTypeErrorText"}
                } else if(fileSize > maxFileSizeInBytes) { // too big
                    fileError = {isError : true, errorTitle: "FilesAllowedErrorTitle", errorText: "FileSizeErrorText"}
                }else if (currentFileName == ""){
                    currentFileName = f.name;
                }else{
                    currentFileName +=(", " + f.name);
                }
            });         
        }
        this.setState({
            files: file, currentFileName: currentFileName, showModal: !fileError.isError,
            fileError
        });
    }

    confirmedUpload() {
        this.setState({ showModal: false, uploadContent: "UploadContentDark"});
        this.uploadFiles();
    }

    cancelUpload() {
        this.setState({ showModal: false, files: [] });
    }

    renderProgress(file) {
        const uploadProgress = this.state.uploadProgress[file.name];
        if (this.state.uploading || this.state.successfullUploaded) {
            return (
                <div className="UploadProgressWrapper">
                    {this.state.uploadError && 
                        <div>
                            <p className={"uploadDocText"}>{this.state.uploadError}</p>
                        </div>
                    }
                    {this.state.documentStatus === this.state.documentApproved &&
                        <div>
                            <div className={"display-flex"}>
                                <BsCheckCircle
                                    className="UploadCheckIcon uploadCheckIcon-margin"
                                    alt="done"
                                    size={25}
                                    color={"green"}

                                />
                                <p className={"uploadDocText"}>{this.state.model.FileName} </p>
                            </div>
                        </div>
                    }
                    {this.state.documentStatus !== "Approved" && !this.state.uploadError &&
                        <div className={"full-width"}>
                            <span className="UploadFilename">{file.name}</span>
                            <ProgressBar progress={uploadProgress ? uploadProgress.percentage : 0} />
                            <BsCheckCircle
                                className="UploadCheckIcon"
                                alt="done"
                                style={{
                                    opacity:
                                        uploadProgress && uploadProgress.state === "done" ? 0.5 : 0
                                }}
                            />
                        </div>
                    }
                </div>
            );
        }
    }

    renderDropZone() {
        if (this.state.documentStatus === this.state.documentApproved) {
            return (
                <div />
            );
        } else {
            return (
                <Dropzone
                    onFilesAdded={this.onFilesAdded}
                    disabled={this.state.uploading}
                />
            );
        }
    }

    async uploadFiles() {
        this.setState({ uploadProgress: {}, uploading: true });
        const {restoreOnDone} = this.props;
        const promises = [];
        this.state.files.forEach(file => {
            promises.push(this.sendRequest(file));
        });
        try {
            await Promise.all(promises);
            if(restoreOnDone !== true){
              this.setState({ successfullUploaded: true, uploading: false });
            }else{
              this.setState({...this.initState})
            }
        } catch (e) {
            // Not Production ready! Do some error handling here instead...
            this.setState({ successfullUploaded: true, uploading: false });
        }
    }

    sendRequest(file) {
        return new Promise((resolve, reject) => {
            let fileBase64 = '';
            this.getBase64(file, (result) => {
                fileBase64 = result;

                const base64Img = fileBase64.split(',');

                let model = {
                    Origin: this.state.origin,
                    OriginType: 2,
                    OriginFileName: file.name,
                    DocType: getDocumentType(file.type),
                    DocMimeType: file.type,
                    ReceivedDateTime: moment().format('M/DD/yyyy h:mm:ss a'),
                    FileName: file.name,
                    LeadId: this.props.leadId,
                    DocumentFile: base64Img[1],
                    DocumentClassification: this.state.documentClassification,
                    userHash : this.props.userHash
                };

                DocumentApi.uploadFile(model).then(result => {
                    if(result.status === 200) {
                      const {restoreOnDone} = this.props;
                      if(restoreOnDone !== true){
                        const newState = {
                          model,
                          documentStatus: "Approved",
                          hideDropZone: true,
                          successfullUploaded: true,
                      };
                      this.setState(newState);
                      }else{
                        this.setState({...this.initState})
                      }
                      

                        if (this.props.onDone) {
                            this.props.onDone(model);
                        }

                    } else {
                        this.setState({
                            uploadError: metadataService.getMessage("ErrorUploadingDocument"),
                            documentStatus: "Error"
                        })
                    }
                });
            });
        });
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
        };
    }
    
    closeFileModal = () => {
        this.setState({fileError: {isError: false }})
    }

    render() {
        const { documentStatus } = this.state;

        return (
          <div style={{ width: "100%" }}>
            <div className="Upload">
              <Card className={this.state.uploadContent + " pt-0"}>
                <CardBody className="p-0">
                  <row>
                    <Card className="p-0">
                      {!this.props.hideTitle && !this.props.hideStatus && (
                        <CardTitle className="UploadTitle">
                          {!this.props.hideTitle ? this.state.uploadTitle : ""}

                          {this.props.hideStatus == false &&
                            this.props.documentStatus &&
                            !this.state.successfullUploaded && (
                              <div>
                                <br />
                                <p className={this.props.documentStatusClass}>
                                  {this.props.documentStatus}
                                </p>
                                <p className={this.props.documentStatusClass}>
                                  {this.props.lastModified === ""
                                    ? ""
                                    : "As of " + this.props.lastModified}
                                </p>
                              </div>
                            )}
                        </CardTitle>
                      )}

                      <CardBody className="p-0">
                        {!this.props.hideDropZone && (
                          <Row>
                            <Col>{this.renderDropZone()}</Col>
                          </Row>
                        )}
                        {this.state.files.length > 0 && (
                          <Row className="pr-3 mr-3">
                            <div className="UploadFiles">
                              {this.state.files.map((file) => {
                                return (
                                  <div key={file.name} className="UploadRow">
                                    {this.renderProgress(file)}
                                  </div>
                                );
                              })}
                            </div>
                          </Row>
                        )}
                      </CardBody>
                    </Card>
                  </row>
                </CardBody>
              </Card>
              <div className="UploadActions" />
            </div>
            <Modal isOpen={this.state.showModal}>
              <ModalHeader>Verify {this.state.uploadTitle || "your"} Upload</ModalHeader>
              <ModalBody>
               { `Are you sure you want to upload ${this.state.currentFileName}${this.state.uploadTitle ?` as
                your ${this.state.uploadTitle}?`:"?"}`}
              </ModalBody>
              <ModalFooter>
                <SlButton onClick={this.confirmedUpload} name={"Yes"} />
                &nbsp;&nbsp;
                <SlButton onClick={this.cancelUpload} name={"No"} />
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.fileError.isError}>
              <ModalHeader>
                {metadataService.getMessage(this.state.fileError.errorTitle)}
              </ModalHeader>
              <ModalBody>
                {metadataService.getMessage(this.state.fileError.errorText)}
              </ModalBody>
              <ModalFooter>
                <SlButton onClick={this.closeFileModal} name={"OK"} />
                &nbsp;&nbsp;
              </ModalFooter>
            </Modal>
          </div>
        );
    }
}

DocumentUpload.propTypes = {
    uploadTitle: PropTypes.string.isRequired,
    leadId: PropTypes.string.isRequired,
    origin: PropTypes.string.isRequired,
    documentClassification: PropTypes.number.isRequired,
    documentStatus: PropTypes.string,
    documentStatusClass: PropTypes.string,
    hideDropZone: PropTypes.bool,
    lastModified: PropTypes.string,
    onDone: PropTypes.func,
    hideTitle : PropTypes.bool,
    hideStatus : PropTypes.bool,
    maxAllowedFiles : PropTypes.number,
    restoreOnDone : PropTypes.bool,
}

DocumentUpload.defaultProps = {
    hideDropZone: false,
    documentStatus: '',
    lastModified: '',
    onDone: null,
    documentStatusClass: 'UploadStatus',
    hideTitle : false,
    hideStatus : false,
    maxAllowedFiles : 1,
    restoreOnDone : false,
}

export default DocumentUpload;


// WEBPACK FOOTER //
// ./src/components/DocumentUpload.jsx